import { formatSize } from 'pano-utils';
import { sendWarning } from '@components/Noti';
import selectFile from '@utils/selectFile';

async function libSelectFiles({
  accept,
  sizeLimit,
}: {
  accept: string[];
  sizeLimit?: number;
}) {
  const files = await selectFile({
    accept: accept.join(','),
    multiple: true,
  });
  let size = 0;
  if (!sizeLimit) {
    for (let i = 0; i < files.length; i++) {
      size += files[i].size;
    }
    return { files, size };
  }
  const arr = [];
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (file.size > sizeLimit) {
      sendWarning(`${file.name} 文件过大，(不能大于${formatSize(sizeLimit)})`);
    } else if (!accept.includes(file.type)) {
      const str = accept.map((s) => `.${s.split('/')[1]}`).join('/');
      sendWarning(`${file.name} 格式不符，仅支持${str}文件`);
    } else {
      arr.push(file);
      size += file.size;
    }
  }
  return { files: arr, size };
}

export default libSelectFiles;
